module.exports = __webpack_public_path__ + "1c1416e5c1247d0da0152c8eeb2552f7.woff2";